The address details to infer a SEEK location from.
